module.exports = "mutation NewUser {\n  createUser {\n    id\n  }\n}\n"